import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import settings from './settings'
import notifications from './notifications/index'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    settings,
    notifications,
  },
  state: {},
  mutations: {},
  actions: {},
})
